<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-subheader class="text-h5 pa-0 pb-4">{{
      $t('DASHBOARD.LATEST_NOTES')
    }}</v-subheader>
    <v-row dense>
      <v-col cols="4">
        <v-autocomplete
          v-model="listFilter.selectedBuildingComplexes"
          :items="buildingComplexes"
          item-value="building_complex_id"
          :item-text="v => v.building_complex_name || $t('ITEM.EMPTY')"
          :label="$t('BUILDING_COMPLEXES.ITEM')"
          chips
          clearable
          outlined
          deletable-chips
          multiple
          small-chips
        ></v-autocomplete>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="listFilter.search"
          :label="$t('ITEM.AUTHOR')"
          outlined
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :sort-by="sortBY"
      :sort-desc="true"
      :search="listFilter.search"
    >
      <template v-slot:item.building_complex_name="{ item }">
        <span class="mr-2">{{ item.building_complex_name }}</span>
        <router-link
          v-if="item.building_complex_id"
          class="text-decoration-none"
          target="_blank"
          :to="{
            name: 'building_complexes.show',
            params: { id: item.building_complex_id }
          }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">
                mdi-eye-outline
              </v-icon>
            </template>
            <span v-if="item.building_complex_name">{{
              item.building_complex_name
            }}</span>
            <span v-else>{{ $t('ITEM.VIEW') }}</span>
          </v-tooltip>
        </router-link>
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="persons.show"
          :route-params="{ id: item.person_id }"
        />
      </template>
    </v-data-table>
  </v-sheet>
</template>

<script>
import moment from 'moment';
import { uniqBy, filter, includes, sortBy } from 'lodash';
import { mapActions, mapState } from 'vuex';
import { cloneDeep, isEmpty } from 'lodash';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'HabitationList',
  components: { ActionSlotComponent },

  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    sortBY: 'created_at',
    listFilter: {
      selectedBuildingComplexes: [],
      search: ''
    }
  }),

  computed: {
    ...mapState('statistic', ['notesFilter']),
    filteredItems() {
      if (!this.listFilter.selectedBuildingComplexes.length) {
        return this.items;
      }

      return filter(this.items, v =>
        includes(
          this.listFilter.selectedBuildingComplexes,
          v.building_complex_id
        )
      );
    },
    buildingComplexes() {
      return sortBy(
        uniqBy(this.items, v => v.building_complex_id),
        ['building_complex_name']
      );
    },
    headers() {
      return [
        {
          text: this.$t('PERSONS.ITEM'),
          value: 'person',
          filterable: false
        },
        {
          text: this.$t('RELATIONS.NOTES'),
          value: 'text',
          filterable: false
        },
        {
          text: this.$t('ITEM.CREATED_AT'),
          value: 'created_at',
          sort: (a, b) =>
            moment(a, ['DD.MM.YYYY']).toDate() -
            moment(b, ['DD.MM.YYYY']).toDate(),
          filterable: false
        },
        {
          text: this.$t('BUILDING_COMPLEXES.ITEM'),
          value: 'building_complex_name',
          filterable: false
        },
        {
          text: this.$t('ITEM.AUTHOR'),
          value: 'username',
          filterable: true
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center',
          filterable: false
        }
      ];
    }
  },

  mounted() {
    if (!isEmpty(this.notesFilter)) {
      this.listFilter = cloneDeep(this.notesFilter);
    }
  },

  beforeDestroy() {
    this.setNotesFilter(this.listFilter);
  },

  methods: {
    ...mapActions('statistic', ['setNotesFilter'])
  }
};
</script>
